
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DimssaButton, ButtonState } from "@/components/shared/dimssa-button.vue";
import { UploadableScanningResult, UploadableModel, HospitalResult, Mortality } from "@/models/uploadable";
import { ScanningResult } from "@gigalot/data-models";
import { sgtinVisualPart } from "@/helpers/sgtin-ui-friendly-tag";
import { hasAccess } from "@/helpers/access-rights";

@Component({
  components: {
    DimssaButton,
  },
})
export default class History extends Vue {
  hideUploaded: boolean = false;

  tab: any = null;

  refreshButtonState: ButtonState = "ready";

  sgtinVisualPart = sgtinVisualPart;
  hasAccess = hasAccess;

  rollCalls: UploadableScanningResult[] = [];
  headCounts: UploadableScanningResult[] = [];
  dispatchesToAbattoirs: UploadableScanningResult[] = [];
  groupWeighs: UploadableScanningResult[] = [];
  groupTreatments: UploadableScanningResult[] = [];
  groupVaccinations: UploadableScanningResult[] = [];
  hospitalResults: HospitalResult[] = [];
  mortalities: Mortality[] = [];

  groupWeighQuantity(scanningResult: ScanningResult) {
    let totalQty = scanningResult.mass.map((me) => me.quantity as number).reduce((p, c) => p + c);
    if (totalQty < scanningResult.tags.length) totalQty = scanningResult.tags.length;
    return totalQty;
  }

  groupWeighMass(scanningResult: ScanningResult) {
    let qty = this.groupWeighQuantity(scanningResult);
    let totMass = scanningResult.mass.map((me) => me.mass).reduce((p, c) => p + c);
    let avgMass = qty > 0 ? Math.round(totMass / qty) : "";
    return `${totMass}kg (${avgMass}kg)`;
  }

  get moment() {
    return this.$store.state.moment;
  }

  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => {
        this.$router.go(-1);
      },
    });
  }

  async mounted() {
    this.refresh();
  }

  sortOnTime(ascending: boolean) {
    return (a: any, b: any) => {
      let ret: number = 0;
      if (a.time < b.time) ret = -1;
      if (a.time === b.time) ret = 0;
      if (a.time > b.time) ret = 1;

      if (!ascending) ret *= -1;

      return ret;
    };
  }

  async refreshUi() {
    this.rollCalls = await this.$store.dispatch("data/getRollCalls");
    if (this.hideUploaded) {
      //hide already uploaded results, show only results that still need to be uploaded
      this.rollCalls = this.rollCalls.filter((rollCall) => !rollCall.uploaded);
    }
    this.headCounts = await this.$store.dispatch("data/getHeadCounts");
    if (this.hideUploaded) {
      //hide already uploaded results, show only results that still need to be uploaded
      this.headCounts = this.headCounts.filter((headCount) => !headCount.uploaded);
    }
    // this.dispatchesToKraals = await this.$store.dispatch("data/getDispatchesToKraals");
    // if (this.hideUploaded) {
    //   //hide already uploaded results, show only results that still need to be uploaded
    //   this.dispatchesToKraals = this.dispatchesToKraals.filter(dispatch => !dispatch.uploaded);
    // }
    this.dispatchesToAbattoirs = await this.$store.dispatch("data/getDispatchesToAbattoirs");
    if (this.hideUploaded) {
      //hide already uploaded results, show only results that still need to be uploaded
      this.dispatchesToAbattoirs = this.dispatchesToAbattoirs.filter((dispatch) => !dispatch.uploaded);
    }
    this.groupWeighs = await this.$store.dispatch("data/getGroupWeighs");
    if (this.hideUploaded) {
      //hide already uploaded results, show only results that still need to be uploaded
      this.groupWeighs = this.groupWeighs.filter((dispatch) => !dispatch.uploaded);
    }
    this.groupTreatments = await this.$store.dispatch("data/getGroupTreatments");
    if (this.hideUploaded) {
      //hide already uploaded results, show only results that still need to be uploaded
      this.groupTreatments = this.groupTreatments.filter((dispatch) => !dispatch.uploaded);
    }
    this.groupVaccinations = await this.$store.dispatch("data/getGroupVaccinations");
    if (this.hideUploaded) {
      //hide already uploaded results, show only results that still need to be uploaded
      this.groupVaccinations = this.groupVaccinations.filter((dispatch) => !dispatch.uploaded);
    }
    this.hospitalResults = await this.$store.dispatch("data/getHospitalResults");
    if (this.hideUploaded) {
      //hide already uploaded results, show only results that still need to be uploaded
      this.hospitalResults = this.hospitalResults.filter((dispatch) => !dispatch.uploaded);
    }
    this.mortalities = await this.$store.dispatch("data/getMortalities");
    if (this.hideUploaded) {
      //hide already uploaded results, show only results that still need to be uploaded
      this.mortalities = this.mortalities.filter((dispatch) => !dispatch.uploaded);
    }

    this.hospitalResults.sort(this.sortOnTime(false));
    this.mortalities.sort(this.sortOnTime(false));
    this.rollCalls.sort(this.sortOnTime(false));
    this.headCounts.sort(this.sortOnTime(false));
    //this.dispatchesToKraals.sort(this.sortOnTime(false));
    this.dispatchesToAbattoirs.sort(this.sortOnTime(false));
    this.groupWeighs.sort(this.sortOnTime(false));
    this.groupTreatments.sort(this.sortOnTime(false));
    this.groupVaccinations.sort(this.sortOnTime(false));
  }

  async refresh() {
    //try {
    if (this.$store.state.upload.isBusyUploading) {
      this.refreshButtonState = "busy";
      this.refreshUi();
      this.$store.dispatch("upload/getNumOnDevice");
      return;
    }
    this.refreshButtonState = "busy";
    await this.refreshUi();
    await this.$store.dispatch("upload/getNumOnDevice");
    await this.$store.dispatch("upload/upload");
    await this.refreshUi();
    this.refreshButtonState = this.$store.state.upload.uploadError ? "error" : "success";
    // } catch (e) {
    // } finally {
    // }
  }

  @Watch("$store.state.upload.isBusyUploading")
  onIsBusyUploadingChanged(val: any) {
    console.log("onIsBusyUploadingChanged", val);
  }
}
